import React, { useEffect } from "react";
import styles from "../assets/scss/pages.module.scss";
import GalleryNavigation from "sections/singleGalleryPage/navigation/GalleryNavigation";
import AboutGallerySection from "sections/singleGalleryPage/aboutGallerySection.jsx/AboutGallerySection";
import HeroSection from "sections/homepage/heroSection/HeroSection";
import ArtworkSection from "sections/singleGalleryPage/artworkSection/ArtworkSection";
import ArtistSection from "sections/singleGalleryPage/artistSection/ArtistSection";
import ExhibitionSection from "sections/singleGalleryPage/exhibitionSection/ExhibitionSection";
import MediaSection from "sections/singleGalleryPage/mediaSection/MediaSection";

const SingleGalleryPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.singleGalleryPage}>
      <div className="container">
        <h2 className={styles.title}>Name Of The Gallery</h2>
      </div>
      <GalleryNavigation />
      <AboutGallerySection />
      <HeroSection />
      <ArtworkSection />
      <ArtistSection />
      <ExhibitionSection />
      <MediaSection />
    </div>
  );
};

export default SingleGalleryPage;
